<div class="container-fluid m-0 p-0">
    <div class="row">
        

        <div class="col-12">

            <div class="bg-white border pt-3 my-4">
                <h5 class="font-16 font-black px-3">{{ "ABSENCE_ASSIGNMENTS" | translate | titlecase }}</h5>
                
                <app-loader [show]="showLoader"></app-loader>
                <div class="table-responsive py-3" >
                    <table class="table-striped" id="datatable">
                        <thead>
                            <tr>
                                <th>{{ "ID" | translate | titlecase }}</th>
                                <th>{{ "STUDENT" | translate | titlecase }}</th>
                                <th>{{ "PRIMARY_TEACHER" | translate | titlecase }}</th>
                                <th>{{ "SECONDARY_TEACHER" | translate | titlecase }}</th>
                                <th>{{ "REMARKS" | translate | titlecase }}</th>
                                <th>{{ "STATUS" | translate | titlecase }}</th>
                                <th>{{ "ASSIGMENT_DES" | translate | titlecase }}</th>
                                <th>{{ "ASSIGNMENT_ANS" | translate | titlecase }}</th>
                                
                                <th class="border-0 font-14 px-2 text-grey">{{ "APPROVE" | translate | titlecase
                                    }}</th>
                                <th class="border-0 font-14 px-2 text-grey">{{ "REJECT" | translate | titlecase
                                    }}</th>
                                
                                <th class="border-0 font-14 px-2 text-grey">{{ "MODIFY" | translate | titlecase }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let res of absenceRequests">
                                <td>{{res?.id}}</td>
                                <td>{{res?.student}}</td>
                                <td>{{res?.primTeacher}}</td>
                                <td>{{res?.secnTeacher}}</td>
                                <td>{{res?.remarks}}</td>
                                <td>{{res?.statusFlag}}</td>
                                <td>{{res?.assignmentDesc}}</td>
                                <td>{{res?.answerDesc}}</td>
                                <td class="text-bold text-warning">
                                    <a class="btn btn-sm btn-link text-success" (click)="approveAssignmentRequest()"><i
                                            class="fas fa-thumbs-up"></i>
                                        {{ "APPROVE" | translate | titlecase }}</a>
                                </td>
                                <td class="text-bold text-warning">
                                    <a class="btn btn-sm btn-link text-danger" (click)="rejectAssignmentRequest()"><i
                                            class="fas fa-ban"></i>
                                        {{ "REJECT" | translate | titlecase }}</a>
                                </td>
                                <td class="text-bold text-warning">
                                    <a class="btn btn-sm btn-link" routerLink="/attendence/absence-assignment-update" [queryParams]="{assID: res?.id}">
                                        <i class="fas fa-edit"></i>
                                        {{ "MODIFY" | translate | titlecase }}</a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>